import { IStorageTransform } from './types';

export default class DefaultTransform<T> implements IStorageTransform<T> {
  toTargetType(data: any): T {
    return data;
  }

  toString(data: T): string {
    return `${data}`;
  }
}
